
export enum AlertMode {
  ERROR = "ERROR",
  WARNING = "WARNING",
  INFO = "INFO"
}